import { Chart } from 'primereact/chart'
import { useTranslation } from 'react-i18next'

import './StatisticsChart.scss'
import Legend from '../../chart-components/legend/Legend'

export default function StatisticsChartCard(props: any) {
  const { t } = useTranslation()
  const { icon, number, inOutData, label, color, legends, data } = props

  const chartData = {
    labels: [legends.firstLegend, legends.secondLegend],
    datasets: [
      data.firstValue.number !== 0 || data.secondValue.number !== 0
        ? {
            data: [data.firstValue.number, data.secondValue.number],
            backgroundColor: [color.firstColor, color.secondColor],
            hoverBackgroundColor: [color.firstColor, color.secondColor],
          }
        : {
            data: [100],
            backgroundColor: ['#cecece'],
            hoverBackgroundColor: ['#cecece'],
          },
    ],
  }

  const options = {
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: data.firstValue.number !== 0 || data.secondValue.number !== 0 ? true : false,
        displayColors: false,
        callbacks: {
          title: (context: any) => {
            return context[0].dataIndex === 0 ? legends.firstLegend : legends.secondLegend
          },
          label: (context: any) => {
            return context.dataIndex === 0
              ? [
                  `${t('dashboard.domestic-office')}: ${inOutData?.desked?.in}`,
                  `${t('dashboard.abroad-office')}: ${inOutData?.desked?.out}`,
                ]
              : [
                  `${t('dashboard.domestic-office')}: ${inOutData?.undesked?.in}`,
                  `${t('dashboard.abroad-office')}: ${inOutData?.undesked?.out}`,
                ]
          },
        },
      },
    },
  }

  return (
    <div className="statistic-container">
      <div className="statistics-total-container">
        <div className="statistic-icon">{icon}</div>
        <div className="statistic-total">
          <div className="d-flex align-items-center">
            <span className="number-total">{number}</span>
          </div>

          <span className="label-text label-title">{label}</span>
          <span className="label-text">
            {t('dashboard.domestic-office')} ({inOutData?.total?.in})
          </span>
          <span className="label-text">
            {t('dashboard.abroad-office')} ({inOutData?.total?.out})
          </span>
        </div>
      </div>

      <div className="chart-container">
        <Chart type="doughnut" data={chartData} className="statistic-chart" options={options} />
        <div className="chart-legends">
          <Legend color={color.firstColor} value={data.firstValue} legend={legends.firstLegend} />
          <Legend color={color.secondColor} value={data.secondValue} legend={legends.secondLegend} />
        </div>
      </div>
    </div>
  )
}
